import { RouteProp, useRoute } from "@react-navigation/native";
import { StyleSheet, View } from "react-native";
import CustomText from "../components/common/general/CustomText/CustomText";
import LTILayout from "../layouts/LTILayout";
import type { RootStackParamList } from "../navigation/navigation.types";

/**
 * Stub view for LTI deep-link activity selection (A4).
 * Faculty lands here after the LMS deep-link launch to pick an activity to link.
 */
function LTIDeepLinkView() {
  const route = useRoute<RouteProp<RootStackParamList, "LTIDeepLink">>();
  const { integrationId, deepLinkStateToken } = route.params ?? {};

  return (
    <LTILayout>
      <View style={styles.container}>
        <CustomText text="Deep Link — Select an Activity" size="l" weight="bold" useTranslationText={false} />
        <CustomText
          text={`Integration: ${integrationId ?? "—"} | Token: ${deepLinkStateToken ? "present" : "missing"}`}
          size="s"
          useTranslationText={false}
          style={styles.meta}
        />
        <CustomText
          text="This view will be implemented in task A4."
          size="m"
          useTranslationText={false}
          style={styles.placeholder}
        />
      </View>
    </LTILayout>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 24,
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
  },
  meta: {
    color: "#6B7280",
  },
  placeholder: {
    color: "#9CA3AF",
    marginTop: 8,
  },
});

export default LTIDeepLinkView;
